import type { DimensionSource, Source } from '@highimpact-frontend/api-types';

// -- type definitions --

export type EntitySelectionKey = `${number}:${number}`;

// -- helper functions --

/**
 * Converts a v2 dimension source into the legacy Source shape used by widget config.
 */
export function dimensionSourceToSource(source: DimensionSource): Source {
  return {
    measure_point_id: source.measure_point_id,
    measure_type_id: source.measure_type_id,
    measurement_unit: source.measurement_unit,
    physical_quantity: source.physical_quantity,
    timezone: source.timezone,
    label: source.label,
  };
}

/**
 * Builds a stable key for a measure-point and measure-type pair.
 */
export function getDimensionSourceKey(source: {
  measure_point_id: number;
  measure_type_id: number;
}): string {
  return `${source.measure_point_id}:${source.measure_type_id}`;
}

/**
 * Builds a stable key for a project-site entity pair.
 */
export function getWidgetEntityKey(entity: {
  project_id: number;
  site_id: number;
}): EntitySelectionKey {
  return `${entity.project_id}:${entity.site_id}`;
}

/**
 * Builds a readable label for a coupled dimension row.
 */
export function getCoupledDimensionRowLabel(
  row: Record<string, DimensionSource>
): string {
  const firstSource = Object.values(row)[0];

  if (!firstSource) {
    return '';
  }

  return `${firstSource.site_name} - ${firstSource.measure_point_name}`;
}
